import Modal from "../../../global/Modal";
import { useDocumentListStore } from "../ViewDocuments/hooks/useDocumentListStore";

import UploadDocumentsContainer from "./UploadDocumentsContainer";

const UploadDocuments = ({ isModal = false }) => {
  const { isUploadModalOpen, setIsUploadModalOpen } = useDocumentListStore();

  const handleCloseUploadModal = () => {
    setIsUploadModalOpen(false);
  };

  if (isModal) {
    return (
      <Modal open={isUploadModalOpen} onClose={handleCloseUploadModal} maxWidth="md">
        <div className="p-6">
          <UploadDocumentsContainer />
        </div>
      </Modal>
    );
  }

  return <UploadDocumentsContainer />;
};

export default UploadDocuments;
